jQuery(document).ready(function () {
    // Add click event listener for clickable elements
    jQuery('.game__medal__team').click(function() {
        // Get the data-index attribute value
        var index = jQuery(this).data('index');
        // Toggle plus and minus icons
        jQuery('.game__medal__team__icon[data-index="' + index + '"]').toggle();
        // Toggle team member holder
        jQuery('#team-holder-' + index).toggle();
    });
})
